/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { Router } from '../providers/Router';
import { ErrorBoundary } from './ErrorBoundary';

const App = () => (
  <ErrorBoundary>
    <Router />
  </ErrorBoundary>
);

export { App };
